import { Controller } from "@hotwired/stimulus"

// Ouvre un <details> quand l'adresse pointe dessus (#son-id), au chargement et au clic sur
// une ancre de la même page. Sert à la check-list « Chiffres du simulateur » (23/09/2026).
export default class extends Controller {
  connect() {
    this.check()
    window.addEventListener("hashchange", this.check)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.check)
  }

  check = () => {
    if (!this.element.id || window.location.hash !== `#${this.element.id}`) return
    this.element.open = true
    this.element.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
